import React from "react";
import { observer } from "mobx-react";
import List from "../../components/List";
import AuthenticationStore from "../../stores/AuthenticationStore";
import Stores from "../../stores/Stores";
import UIStore from "../../stores/UIStore";
import Edit from "./Edit";
import SearchField from "../../components/SearchField";
import SortPanel from "../../components/SortPanel";
import { baseUrl } from "../../utils/Client";
import dayjs from "dayjs";


const store = Stores.load("hops-cups");

class HopsCups extends React.Component {
  state = {
    
  }

  componentDidMount() {
    UIStore.init("Copa Brasileira de Lúpulos", store);
  }

  handleDelete = () => {
    let count = store.selected.length;

    UIStore.showConfirmDialog(
      `Deseja remover ${count} eventos?`,
      "Remover Eventos"
    ).then((b) => {
      if (b) {
        store
          .delete()
          .then(() => store.query())
          .catch(() => alert("Erro!"));
      }
    });
  };

  handleFilter = () => {
    store.page = 0;
    store.searchAll = !store.searchAll;
    store.query();
  };

  render() {
    const toggleFilters = (
      <ul className="filters-list">
        <li>
          <div
            className={!store.searchAll ? "activated" : ""}
            onClick={this.handleFilter}
          >
            Liberados
          </div>
        </li>
        <li>
          <div
            className={store.searchAll ? "activated" : ""}
            onClick={this.handleFilter}
          >
            Todos
          </div>
        </li>
      </ul>
    );
    const canEdit = AuthenticationStore.me.role !== "MANAGER";

    return (
      <>
        <List
          store={store}
          data={store.list.map((i) => ({
            item: i,
            title: (!!i.name ? i.name : "Sem nome") + ` - ${dayjs(i.startDate).format("DD/MM/YYYY")} até ${dayjs(i.validUntil).format("DD/MM/YYYY")}`,
            content: (
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                <img 
                  src={`${baseUrl}/img/hops-cup-banner/${i.id}/250/125?count=${i.bannerImgCount}`}
                  alt="banner"
                  style={{ borderRadius: 15, width: 250, height: 125 }}
                />
                <div style={{ marginLeft: 10 }}>
                  Adicionado em:{" "}
                  {i.createdDate ? i.createdDate.formatTimeStamp() : ""}
                  <br />
                </div>
              </div>
            ),
          }))}
          status={store.list.map((i) => ({
            id: i.id,
            label: i.enabled ? "Liberado" : "Desativado",
            class: i.enabled ? "finished-status" : "canceled-status",
          }))}
          rightPanel={
            <>
              <SortPanel
                store={store}
                filters={{
                  name: "Nome",
                  createdDate: "Data de Adição",
                  startDate: "Data de início",
                  validUntil: "Data de finalização",
                }}
              />
              <SearchField store={store} />
            </>
          }
          leftPanel={toggleFilters}
          onAdd={
            canEdit
              ? () =>
                  store.new({
                    name: "",
                    startDate: "",
                    validUntil: "",
                    description: "",
                    homeImg: null,
                    bannerImg: null,
                    organizers: [],
                  })
              : null
          }
          onEdit={canEdit ? () => store.open() : null}
          onDelete={canEdit ? () => this.handleDelete() : null}
        />

        <Edit 
          onSave={() => AuthenticationStore.testAuthenticated()} 
        />
      </>
    );
  }
}

export default observer(HopsCups);
